module.exports = __webpack_public_path__ + "img/russiamedtravel.d1650aa9.jpg";